import { render, staticRenderFns } from "./CustomRegisterContainer.vue?vue&type=template&id=24fd9892&scoped=true"
import script from "./CustomRegisterContainer.vue?vue&type=script&lang=js"
export * from "./CustomRegisterContainer.vue?vue&type=script&lang=js"
import style0 from "./CustomRegisterContainer.vue?vue&type=style&index=0&id=24fd9892&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fd9892",
  null
  
)

export default component.exports